import { gsap } from 'gsap';

export default class{

    constructor( options ) {
        this.defaults = {
        	$el: false
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace 		= 	'module_grid_filter';
		this.$el 			= 	this.options.$el;
		this.main			=   this.options.main;

        this.grid           =   this.$el.find('[data-gridfilter="target"]');
        this.control        =   this.$el.find('A[rel="gridfilter:filter"]');
        this.items          =   this.grid.find('.item-grid');

        this.filter_toggle  =   this.$el.find('A[rel="gridfilter:toggle"]');
        this.filter_panel   =   this.$el.find('.filters-panel');

		if ( this.$el.length > 0 ){
			this.init();
		}
    }

    init(){
    	this.addEvents( true );

        // console.log('initModuleGridFilter');
        // console.log(this.$el[0], 'element');
        // console.log(this.control, 'control');

	}

	//---------------------------------------- EVENTS ---------------------------------------//
	addEvents( b ){
		if ( b ){
			this.filter_toggle.on( 'click', () => this.toggleFilterPanel() );
            this.control.on( 'click', (e) => this.doFilter(e) );
		}
		else{
            this.filter_toggle.off( 'click' );
			this.control.off( 'click' );
		}
	}

    toggleFilterPanel() {

        this.filter_toggle.toggleClass('open');
        this.filter_panel.slideToggle(200);

        return false;
    }

	doFilter(e){

        let link = $(e.currentTarget);

        this.filter_toggle.removeClass('open');
        this.filter_panel.slideUp();

        let name        = link.html();
        let attribute   = link.data('value');
        let items_show  = false;
        let panel       = this.filter_panel;

        this.items.hide();

        if (attribute == '*') {
            items_show = this.items;
            this.filter_toggle.html('Filters');
            setTimeout(function() {
                panel.find('.view-all').hide();
            }, 200);
        } else {
            items_show = this.items.filter('[data-attributes*="|'+ attribute +'|"]');
            this.filter_toggle.html(name);
            setTimeout(function() {
                panel.find('.view-all').show();
            }, 200);
        }

        items_show.show();

        // TweenMax.fromTo(this.grid, 0.4, {opacity:0.2, y:10}, {opacity:1, y:0, ease:"Power.easeOut"});

        gsap.set(this.grid, { opacity:0, y:20 });
        gsap.to(this.grid, { duration:0.9, ease:"power2.out", opacity:1, y:0 });

        return false;

 	}

    //---------------------------------------- METHODS ---------------------------------------//
    destroy(){
		if ( this.$el.length > 0 ){
    		this.addEvents( false );
    	}
    }

}


